export default [
    {
        path: "/report/vehicle/in-out-list",
        component: () => import("./List.vue"),
        name: "report-vehicle-in-out-list",
        meta: {
            requiresAuth: true,
        },
    },
];
